import { render, staticRenderFns } from "./GeneralConfig.vue?vue&type=template&id=51ea5558&scoped=true"
import script from "./GeneralConfig.vue?vue&type=script&lang=js"
export * from "./GeneralConfig.vue?vue&type=script&lang=js"
import style0 from "./GeneralConfig.vue?vue&type=style&index=0&id=51ea5558&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ea5558",
  null
  
)

export default component.exports